import React from 'react';
import { Row } from '../RowCol';
import Spacer from '../Spacer';
import styles from '../../style';

type Level = number;

type Props = {
	level: Level;
	isOpen: boolean;
	onClick: () => void;
	className?: string;
	dd?: boolean;
};

const DollarSquare: React.FC<Props> = ({
	level,
	isOpen,
	onClick,
	className,
	dd,
}) => {
	return (
		<Row center
			onClick={isOpen ? () => undefined : onClick}
			style={{
				backgroundColor: styles.squareBackgroundColor,
				width: styles.squareWidth,
				height: styles.squareHeight,
				justifyContent: 'center',
				alignItems: 'center',
				position: 'relative',
				...(isOpen ? {} : {
					cursor: 'pointer',
				}),
			}}
			className={className}
		>
			<div
				style={{
					color: styles.dollarColor,
					fontSize: styles.dollarSignFontSize,
					fontFamily: styles.dollarFont,
					textShadow: styles.shadow4,
				}}
			>
				{isOpen ? '' : '$'}
			</div>
			<Spacer horizontal={5} />
			<div
				style={{
					color: styles.dollarColor,
					fontSize: styles.dollarNumberFontSize,
					fontFamily: styles.dollarFont,
					textShadow: styles.shadow4,
					letterSpacing: '1.5px',
				}}
			>
				{isOpen ? '' : `${level}`}
			</div>
			{dd && (
				<div style={{
					position: 'absolute',
					top: 3,
					right: 3,
					fontSize: '14px',
				}}>
					DD
				</div>
			)}
		</Row>
	);
};

export default DollarSquare;
